// Tracks whether the user has already discovered (or dismissed) the
// Words feature callout shown on the story-finished screen.
//
// Stored as a per-device flag in localStorage. The callout becomes hidden
// when:
//   - the user explicitly dismisses it (× button)
//   - the user clicks the CTA (we navigate them to /words)
//   - the user lands on the Words page through any other entry point
//     (header nav link), which also marks it dismissed
//
// We intentionally avoid a backend preference for v1 to keep this shippable
// and zero-risk. Promoting to a user preference field later is straightforward.

const STORAGE_KEY = 'maayot.wordsCalloutDismissed'

export const isWordsCalloutDismissed = (): boolean => {
  try {
    if (typeof window === 'undefined') return false
    return window.localStorage.getItem(STORAGE_KEY) === 'true'
  } catch {
    // Private mode / disabled storage — fail safe to "dismissed" so we
    // never get stuck showing the callout to a user who can't dismiss it.
    return true
  }
}

export const dismissWordsCallout = (): void => {
  try {
    if (typeof window === 'undefined') return
    window.localStorage.setItem(STORAGE_KEY, 'true')
  } catch {
    // Ignore storage failures — the callout will simply re-appear next session.
  }
}
